import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories, MAIN_SITE_URL } from '@/mocks/categories';

const categoryImages: Record<number, string> = {
  911: 'https://readdy.ai/api/search-image?query=Sneakers%20on%20clean%20white%20surface%20with%20natural%20light%2C%20minimalist%20product%20photography%2C%20warm%20tones&width=200&height=150&seq=nav-cat-shoes-01&orientation=landscape',
  912: 'https://readdy.ai/api/search-image?query=Premium%20hoodie%20on%20wooden%20hanger%20cream%20wall%2C%20soft%20natural%20light%2C%20minimalist%20fashion%20photography&width=200&height=150&seq=nav-cat-hoodies-01&orientation=landscape',
  913: 'https://readdy.ai/api/search-image?query=White%20cotton%20t-shirt%20folded%20on%20wood%20surface%2C%20soft%20morning%20light%2C%20minimalist%20apparel%20photography&width=200&height=150&seq=nav-cat-tshirts-01&orientation=landscape',
  914: 'https://readdy.ai/api/search-image?query=Leather%20jacket%20on%20wooden%20stand%20beige%20background%2C%20warm%20studio%20lighting%2C%20editorial%20fashion%20photography&width=200&height=150&seq=nav-cat-jackets-01&orientation=landscape',
  915: 'https://readdy.ai/api/search-image?query=Well-tailored%20pants%20folded%20on%20cream%20linen%2C%20soft%20daylight%2C%20minimalist%20fashion%20photography&width=200&height=150&seq=nav-cat-pants-01&orientation=landscape',
  916: 'https://readdy.ai/api/search-image?query=Baseball%20cap%20and%20beanie%20on%20white%20surface%2C%20window%20light%2C%20minimalist%20accessories%20photography&width=200&height=150&seq=nav-cat-headwear-01&orientation=landscape',
  917: 'https://readdy.ai/api/search-image?query=Matching%20outfit%20set%20on%20clothing%20rack%20cream%20wall%2C%20natural%20daylight%2C%20warm%20neutral%20tones&width=200&height=150&seq=nav-cat-sets-01&orientation=landscape',
  918: 'https://readdy.ai/api/search-image?query=Cotton%20basics%20folded%20on%20linen%20surface%2C%20morning%20light%2C%20minimalist%20apparel%20photography&width=200&height=150&seq=nav-cat-underwear-01&orientation=landscape',
  919: 'https://readdy.ai/api/search-image?query=Sports%20jersey%20on%20white%20surface%2C%20bright%20daylight%2C%20athletic%20apparel%20photography&width=200&height=150&seq=nav-cat-jersey-01&orientation=landscape',
  920: 'https://readdy.ai/api/search-image?query=Watch%20bracelet%20sunglasses%20on%20cream%20surface%2C%20morning%20light%2C%20minimalist%20product%20photography&width=200&height=150&seq=nav-cat-accessories-01&orientation=landscape',
  921: 'https://readdy.ai/api/search-image?query=Leather%20backpack%20tote%20on%20white%20surface%2C%20natural%20daylight%2C%20minimalist%20product%20photography&width=200&height=150&seq=nav-cat-bags-01&orientation=landscape',
  922: 'https://readdy.ai/api/search-image?query=Leather%20belt%20coiled%20on%20linen%20surface%2C%20morning%20light%2C%20minimalist%20accessories%20photography&width=200&height=150&seq=nav-cat-belts-01&orientation=landscape',
  923: 'https://readdy.ai/api/search-image?query=Perfume%20bottle%20on%20marble%20surface%2C%20daylight%20with%20floral%20accents%2C%20minimalist%20fragrance%20photography&width=200&height=150&seq=nav-cat-perfumes-01&orientation=landscape',
  924: 'https://readdy.ai/api/search-image?query=Lifestyle%20products%20accessories%20gadgets%20on%20white%20surface%2C%20natural%20daylight%2C%20organized%20grid%20layout&width=200&height=150&seq=nav-cat-other-01&orientation=landscape',
};

export default function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50/95 backdrop-blur-md border-b border-background-200/50">
      <nav className="max-w-[1440px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 cursor-pointer group flex-shrink-0">
            <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-database-2-line text-lg text-white"></i>
            </div>
            <span className="font-heading text-lg md:text-xl text-foreground-950 whitespace-nowrap group-hover:text-primary-600 transition-colors">
              VigorBuy Spreadsheet
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            <Link to="/" className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors rounded-md whitespace-nowrap cursor-pointer">Home</Link>
            <Link to="/vigorbuy-spreadsheet-guide" className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors rounded-md whitespace-nowrap cursor-pointer font-medium">Shopping Guide</Link>
            <a href="#categories" className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors rounded-md whitespace-nowrap cursor-pointer">Categories</a>

            <div ref={dropdownRef} className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center gap-1 px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors rounded-md whitespace-nowrap cursor-pointer"
              >
                Browse Products
                <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {dropdownOpen && (
                <div className="absolute top-full left-0 mt-1 w-72 bg-background-50 rounded-xl border border-background-200/70 shadow-lg py-3 max-h-[500px] overflow-y-auto z-50">
                  {categories.map((cat) => {
                    const catImage = categoryImages[cat.id];
                    return (
                      <a
                        key={cat.id}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
                      >
                        <div className="w-10 h-10 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
                          {catImage && (
                            <img src={catImage} alt={cat.name} className="w-full h-full object-cover" />
                          )}
                        </div>
                        <span className="whitespace-nowrap">{cat.name}</span>
                      </a>
                    );
                  })}
                </div>
              )}
            </div>

            <a href="#guide" className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors rounded-md whitespace-nowrap cursor-pointer">Guide</a>
            <a href="#safety" className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors rounded-md whitespace-nowrap cursor-pointer">Safety</a>
            <a href="#faq" className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors rounded-md whitespace-nowrap cursor-pointer">FAQ</a>
            <a href="#articles" className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors rounded-md whitespace-nowrap cursor-pointer">Guides</a>
          </div>

          <div className="hidden lg:flex items-center gap-3 flex-shrink-0">
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="px-4 py-2 text-sm font-medium border border-background-300 text-foreground-700 rounded-full hover:border-primary-300 hover:text-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              VigorBuy Spreadsheet
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="px-4 py-2 text-sm font-medium bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden w-9 h-9 flex items-center justify-center text-foreground-700 cursor-pointer flex-shrink-0"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="lg:hidden pb-6 pt-3 border-t border-background-200/50">
            <div className="flex flex-col">
              <Link to="/" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-lg cursor-pointer transition-colors">
                <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className="ri-home-4-line text-sm text-primary-600"></i>
                </div>
                Home
              </Link>
              <Link to="/vigorbuy-spreadsheet-guide" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-lg cursor-pointer transition-colors">
                <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className="ri-book-open-line text-sm text-accent-600"></i>
                </div>
                Shopping Guide
              </Link>
              <a href="#categories" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-lg cursor-pointer transition-colors">
                <div className="w-8 h-8 rounded-lg bg-secondary-100 flex items-center justify-center">
                  <i className="ri-grid-line text-sm text-secondary-600"></i>
                </div>
                Categories
              </a>

              <button
                onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
                className="flex items-center justify-between w-full px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-lg cursor-pointer transition-colors"
              >
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className="ri-shopping-bag-3-line text-sm text-primary-600"></i>
                  </div>
                  Browse Products
                </div>
                <div className="w-5 h-5 flex items-center justify-center transition-transform duration-200" style={{ transform: mobileDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                  <i className="ri-arrow-down-s-line text-sm text-foreground-500"></i>
                </div>
              </button>
              {mobileDropdownOpen && (
                <div className="ml-4 mt-1 mb-1 border-l-2 border-primary-200 pl-3">
                  <div className="grid grid-cols-1 gap-1 max-h-[360px] overflow-y-auto">
                    {categories.map((cat) => {
                      const catImage = categoryImages[cat.id];
                      return (
                        <a
                          key={cat.id}
                          href={cat.url}
                          target="_blank"
                          rel="noopener nofollow"
                          className="flex items-center gap-3 px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 rounded-lg cursor-pointer transition-colors"
                        >
                          <div className="w-9 h-9 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
                            {catImage && (
                              <img src={catImage} alt={cat.name} className="w-full h-full object-cover" />
                            )}
                          </div>
                          <span className="whitespace-nowrap text-xs">{cat.name}</span>
                        </a>
                      );
                    })}
                  </div>
                </div>
              )}

              <a href="#guide" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-3 py-3 text-sm text-foreground-700 hover:bg-background-100 rounded-lg cursor-pointer transition-colors">
                <div className="w-8 h-8 rounded-lg bg-background-200 flex items-center justify-center">
                  <i className="ri-compass-3-line text-sm text-foreground-500"></i>
                </div>
                Guide
              </a>
              <a href="#safety" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-3 py-3 text-sm text-foreground-700 hover:bg-background-100 rounded-lg cursor-pointer transition-colors">
                <div className="w-8 h-8 rounded-lg bg-background-200 flex items-center justify-center">
                  <i className="ri-shield-check-line text-sm text-foreground-500"></i>
                </div>
                Safety
              </a>
              <a href="#faq" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-3 py-3 text-sm text-foreground-700 hover:bg-background-100 rounded-lg cursor-pointer transition-colors">
                <div className="w-8 h-8 rounded-lg bg-background-200 flex items-center justify-center">
                  <i className="ri-question-answer-line text-sm text-foreground-500"></i>
                </div>
                FAQ
              </a>
              <a href="#articles" onClick={() => setMobileOpen(false)} className="flex items-center gap-2 px-3 py-3 text-sm text-foreground-700 hover:bg-background-100 rounded-lg cursor-pointer transition-colors">
                <div className="w-8 h-8 rounded-lg bg-background-200 flex items-center justify-center">
                  <i className="ri-article-line text-sm text-foreground-500"></i>
                </div>
                Guides
              </a>

              <div className="border-t border-background-200/50 mt-2 pt-3 px-3">
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block w-full text-center px-4 py-3 text-sm font-medium border border-background-300 text-foreground-700 rounded-full hover:border-primary-300 hover:text-primary-600 transition-all cursor-pointer mb-2"
                >
                  VigorBuy Spreadsheet
                </a>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block w-full text-center px-4 py-3 text-sm font-medium bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-colors cursor-pointer"
                >
                  Buy It Now
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}